import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { updateUserCoins, profile, updateCoins } from '../../slices/userSlice'; // Atualize as moedas no Redux

const BuyCoins = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isAdPlaying, setIsAdPlaying] = useState(false);
  const [adCompleted, setAdCompleted] = useState(false);

  const coinsEarned = 10; // Defina quantas moedas o jogador ganha por vídeo.

  useEffect(() => {
    const fetchProfile = async () => {
      dispatch(profile());
    };

    fetchProfile();
  }, [dispatch]);

  // Mock para exibir o anúncio
  const playAd = () => {
    if (isAdPlaying) return;

    setIsAdPlaying(true);
    console.log("Ad iniciado. Exibindo anúncio...");
    
    // Simular tempo de exibição do anúncio
    setTimeout(() => {
      console.log("Ad concluído!");
      setAdCompleted(true);
      setIsAdPlaying(false);
    }, 5000); // 5 segundos como simulação
  };
  const coinsData = {
    coins: coinsEarned,
    userId: user._id
  }
  // Quando o anúncio termina, adiciona moedas ao jogador
  const rewardUser = async () => {
    if (!adCompleted) return;
    const res = await dispatch(updateUserCoins(coinsData));
    await dispatch(updateCoins({coinsEarned: res.payload.coinsEarned}));
    await setAdCompleted(false); // Reseta o estado para novos anúncios
    await alert(`Você ganhou ${coinsEarned} moedas!`);
  };

  return (
    <div className="text-center p-4 min-h-dvh">
      <button
        onClick={playAd}
        disabled={isAdPlaying}
        className={`px-4 py-2 bg-blue-500 text-white rounded ${isAdPlaying ? "opacity-50" : "hover:bg-blue-700"}`}
      >
        {isAdPlaying ? "Assistindo..." : "Assistir vídeo e ganhar moedas"}
      </button>

      {/* Simular recompensa após o anúncio */}
      {adCompleted && (
        <button
          onClick={rewardUser}
          className="mt-4 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-700"
        >
          Recolher Recompensa
        </button>
      )}
    </div>
  );
}

export default BuyCoins;
